import api from '@/services/api/api';

export const useGame = (
  params = {
    page: 1,
  },
) => {
  const games = useInfiniteQuery(
    ['games', params.page],
    async ({ pageParam = toValue(params.page) }) => {
      const { data } = await api.games.getGameArticles({
        per_page: params.per_page,
        page: pageParam,
        isMainPage: params.isMainPage || false,
      });

      return data;
    },
    {
      staleTime: Infinity,
      select: ({ pages }) => ({
        meta: pages[pages.length - 1].meta,
        data: pages.flatMap((data) => data.data),
      }),
      getNextPageParam: (data) => {
        return data.meta.current_page < data.meta.last_page
          ? data.meta.current_page + 1
          : undefined;
      },
      refetchOnMount: true,
      keepPreviousData: true,
    },
  );

  onServerPrefetch(async () => {
    await games.suspense();
  });

  return {
    games,
  };
};
